import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommonFunction } from 'src/app/grievance/common-function';
import { GrievanceList } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';

import { SupportUserAssignedGrievanceService } from './support-user-assigned-grievance.service';

const COLS = [
  { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
  { value: "CREATED DATE", lowercaseValue: "createdOn", displayName: "Created Date" },
  { value: "GRIEVANCE ID", lowercaseValue: "pkUsgrid", displayName: "Grievance Id" },
  { value: "GRIEVANCE TYPE", lowercaseValue: "grivType", displayName: "Grievance Type" },
  { value: "SUBJECT", lowercaseValue: "usGriSubject", displayName: "Subject" },
  { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
];


@Component({
  selector: 'app-suppport-user-assigned-grievance',
  templateUrl: './support-user-assigned-grievance.component.html',
  styleUrls: ['./support-user-assigned-grievance.component.scss'],
})
export class SuppportUserAssignedGrievanceComponent implements OnInit {
  displayedCols = COLS;
  allCols = COLS;
  displayedColumns: any[];
  grievanceList: GrievanceList[] = [];
  grievancenoData = ProjectConstants.grievanceNotAvailable;
  dataSource = new MatTableDataSource(this.grievanceList);
  filterForm: FormGroup = new FormGroup({});
  progressSpinnerDialog: any = null;
  @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatPaginator)
  // set paginator(value: MatPaginator) {
  //   this.dataSource.paginator = value;
  // }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  statusList = []
  pageEvent: PageEvent;
  selectedReport: any = null
  pageSize: any;
  pageIndex: any;
  pageSizeOptions: number[] = [10, 20, 50];
  currentPage: any;
  totalRows = 0;
  constructor(public supportUserGrievanceService: SupportUserAssignedGrievanceService,
    public dialog: MatDialog,
    public commonFunction: CommonFunction,
    public datepipe: DatePipe,
    public router: Router) { }

  ngOnInit() {


    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required])
    });
    var index = localStorage.getItem("assignPageIndex")
    if (index == null) {
      this.currentPage = Number(localStorage.setItem("assignPageIndex", "0"))

    } else {
      this.currentPage = Number(localStorage.getItem("assignPageIndex"))
    }
    var size = localStorage.getItem("assignPageSize")
    if (size == null) {
      this.pageSize = Number(localStorage.setItem("assignPageSize", "10"))

    } else {
      this.pageSize = Number(localStorage.getItem("assignPageSize"))
    }
    this.displayedCols = [
      { value: "GRIEVANCE ID", lowercaseValue: "pkUsgrid", displayName: "Grievance Id" },
      { value: "CREATED DATE", lowercaseValue: "createdOn", displayName: "Created Date" },
      { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
      { value: "GRIEVANCE TYPE", lowercaseValue: "grivType", displayName: "Grievance Type" },
      { value: "SUBJECT", lowercaseValue: "usGriSubject", displayName: "Subject" },
      { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
    ];
    this.dataSource.paginator = this.paginator;
    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.loadMasterStatus();
    this.loadData(this.selectedReport);
  }
  //


  async loadMasterStatus() {
    // this.displayProgressSpinner();
    const response: any = await this.supportUserGrievanceService.loadStatus();
    // this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          this.statusList = response
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.statusList = []
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }


  async getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.currentPage = this.pageIndex
    localStorage.setItem("assignPageIndex", this.currentPage);
    localStorage.setItem("assignPageSize", this.pageSize);
    this.loadData(this.selectedReport);
  }


  async loadData(statusId) {
    this.grievanceList = []
    this.displayProgressSpinner();
    const response1: any = await this.supportUserGrievanceService.loadAssignGrievanceStatus(this.currentPage, this.pageSize, statusId);
    this.progressSpinnerDialog.close()
    if (response1 != null && !response1.error) {
      if (response1.content.length != 0) {
        const response: any = response1.content
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          // console.log(response)
          for (var i = 0; i < response.length; i++) {
            // var updated_date = response[i].updatedOn
            var updated_date = (response[i].updatedOn != null && response[i].updatedOn.includes("+")) ? response[i].updatedOn.split("+")[0] : response[i].updatedOn

            let updated_on = this.datepipe.transform(updated_date, 'dd/MM/yyyy hh:mm a');
            // var created_date = response[i].createdOn
             var created_date = (response[i].createdOn != null && response[i].createdOn.includes("+")) ? response[i].createdOn.split("+")[0] : response[i].createdOn

            let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm a');
            const customObj = new GrievanceList();
            customObj.pkUsgrid = response[i].pkUsgrid
            customObj.boardName = response[i].boardName
            customObj.grivType = this.text_truncate(response[i].grivType, 30, '....')
            customObj.usGriSubject = this.text_truncate(response[i].usGriSubject, 30, '....');
            customObj.createdOn = created_on
            customObj.updatedOn = updated_on
            customObj.statusName = response[i].statusName
            if (response[i].fkStid == 1 || response[i].fkStid == 2) {
              customObj.checkTransferStatus = true
            }
            this.grievanceList.push(customObj)
          }
          this.dataSource.data = this.grievanceList;
          setTimeout(() => {
            // this.paginator.pageIndex = this.currentPage;
            this.paginator.length = response1.totalElements;
          });
        } else if (response[0].status = ProjectConstants.responseStatusFailure) {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.grievanceList = []
        this.dataSource = new MatTableDataSource(this.grievanceList);
      }
      this.displayedColumns = this.displayedCols.map((col) => col.value);
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }

  //progress bar
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }
  //


  //grievance subject truncate function
  text_truncate(str, length, ending) {
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  }
  //

  //go to assigned grievance forward
  gotoAssignedGrievance(grievanceId: any) {
    this.router.navigate(['secure/assigned-grievance-view/' + grievanceId])
  }
  //

  // go to assigned grievance view
  goToGrievanceView(grievanceId: any) {
    this.router.navigate(['secure/assgined-grievance-view-reply/' + grievanceId])
  }
  //

  applyFilter(search: any) {
    const filterValue = search;
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    const filterValue = ''
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}


